export const ApiRoles = {
    getManagerRoles: params => ({
        url: '/users-permissions/getManagerRoles',
        method: 'GET',
        params
    })
};